export default __webpack_public_path__ + "static/media/user-avatar-blank.d9398c19.png";